<script lang="ts">
  import type { NrknoPlayerElement } from '@nrk/nrkno-player';
  import '@nrk/nrkno-player/index.css';
  import { onMount } from 'svelte';
  import { get } from 'svelte/store';
  import { loginSessionStore } from '../login/loginSessionStore';
  import { SNOWPLOW_APP_ID } from '../util/snowplow';
  export let videoId: string;
  const playerId = `player:${videoId}`;
  const user: NrknoPlayerElement['user'] = {
    get id() {
      return get(loginSessionStore)?.user?.sub;
    },
    async getAuthToken() {
      return get(loginSessionStore)?.accessToken;
    },
  };
  const psapiOrigin =
    import.meta.env.MODE !== 'production' ? 'http://localhost:9203' : undefined;
  onMount(async () => {
    import('@nrk/nrkno-player').then(({ NrknoPlayerElement }) => {
      if (!window.customElements.get('nrkno-player')) {
        window.customElements.define('nrkno-player', NrknoPlayerElement);
      }
    });
  });
</script>

{#await window.customElements.whenDefined('nrkno-player')}
  <!--
    Svelte does not add properties to custom elements that are not defined yet,
    not even when the element gets defined later.  This means that we have to wait
    for the element to be defined before we can use it.
    In the meantime show a black frame with the same aspect ratio as the player.
    -->
  <div class="-player cover aspect-ratio aspect-ratio--16x9" />
{:then}
  <nrkno-player
    id={playerId}
    {psapiOrigin}
    {user}
    type="player"
    src="nrk:{videoId}"
    snowplowAppId={SNOWPLOW_APP_ID}
    snowplowurl={import.meta.env.VITE_SNOWPLOW_URL}
    disableAutopause
    class="-player cover aspect-ratio aspect-ratio--16x9"
  />
{/await}
